import {
  Filter
} from '../common/filter';

const updateFilter = f => {
  f.timeTo = null;
  f.timeFrom = f.timeTo;
  f.record_count = 0;
  Object.setPrototypeOf(f, Filter.prototype);
  f.typize();
  return f;
};

export class FilterResource {
  constructor(
    $http,
    $q,
  ) {
    this.$http = $http;
    this.$q = $q;
  }

  // Delete saved filter (ID should be set)
  delete(filter) {
    return this.$http.post('/analytics/filter/delete/', {
        id: filter.id
      })
      .then(({
        data,
        status
      }) => {
        return {
          data,
          status
        };
      })
      .catch(({
        data,
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }

  // Save filter to server, get ID
  save(filter, callback) {
    const filterData = Object.assign({}, filter);
    filterData.content_type = filter.content_type;
    filterData.category = filter.category;
    if (!filter.isGraph) delete filterData.graphOptions;
    delete filterData.isNodeOpen;
    return this.$http.post('/analytics/filter/save/', filterData)
      .then(({
        data,
        status
      }) => {
        filter.saved = true;
        filter.isChanged = false;
        filter.id = data.id;
        if (!filter.children || !filter.children.length) filter.children = data.children;
        else data.children = filter.children;
        callback && callback(status, filter, null);
        return {
          data,
          status
        };
      })
      .catch(({
        data,
        status
      }) => {
        const err = new Error('HTTP error: ' + status);
        err.data = data;
        callback && callback(status, data, err);
      });
  }

  // id: position.id,
  // prev_id: position.prev_id,
  // parent_id: position.parent_id,
  changePosition(id, prev_id, parent_id) {
    return this.$http.post('/analytics/filter/update_position/', {
      id,
      prev_id,
      parent_id
    });
  }

  // Return list of all filters
  list(id) {
    const url = id === null || id === undefined ?
      '/analytics/filter/list/' : `/analytics/filter/list/?parentId=${id}`;
    return this.$http.get(url, {})
      .then(({
        data
      }) => {
        const result = data.map(updateFilter);
        return result;
      })
      .catch(({
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }

  listOther(filterIds, id) {
    return this.$http.post('/analytics/filter/list_other/', {
        loadedIds: filterIds ? filterIds : [],
        id: id
      })
      .then(({
        data,
        status
      }) => {
        const result = data.map(updateFilter);
        return result;
      })
      .catch(({
        data,
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }

  search(searchTrim = '', id = null) {
    let url = `/analytics/filter/search/?searchTrim=${searchTrim}`;
    if (id != null) url = `${url}&id=${id}`;
    return this.$http.get(url, {})
      .then(({
        data
      }) => {
        return data;
      })
      .catch(({
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }


  checkRegExps(regExps) {
    this.error = null;
    return new Promise(resolve => Promise.all(regExps.map(keyword => this.checkRegExp(keyword)))
      .then(res => {
        resolve(this.error);
      }));
  }

  checkRegExp(regExp) {
    return new Promise(resolve => {
      if (this.error) {
        resolve(null);
        return null;
      }
      if (regExp[0] == '~') {
        this.$http.get(`/analytics/check_regexp/?regexp=${regExp}`)
          .then(res => {
            if (res.data.error) {
              this.error = `"${regExp.substr(1)}" ${res.data.error}`;
            }
            resolve(this.error);

          });
      } else {
        resolve(null);
      }
    });
  }

  matchEventTextData(regExp) {
    return this.$http.get(`/analytics/match_event_text_data/?regexp=${regExp}`)
      .then(({
        data
      }) => {
        return data;
      })
      .catch(({
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }

}



// WEBPACK FOOTER //
// ./src/core/filter-resource.service.js